import { render } from "./AppSectionTitle.vue?vue&type=template&id=1c5f7969&scoped=true&ts=true&lang=pug"
import script from "./AppSectionTitle.vue?vue&type=script&lang=ts"
export * from "./AppSectionTitle.vue?vue&type=script&lang=ts"

import "./AppSectionTitle.vue?vue&type=style&index=0&id=1c5f7969&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5f7969"]])

export default __exports__